import { PAN, GSTIN, VALUE } from '../../../constants';

export function sortVendorKycDocuments(documents) {
  documents.sort((a, b) => {
    if (a.docName === PAN) {
      return -1;
    }
    if (a.docName === GSTIN) {
      if (b.docName === PAN) {
        return 1;
      }
      if (b.docName === GSTIN) {
        return -1;
      }
      return 1;
    }
    if (b.docName === PAN || b.docName === GSTIN) {
      return 1;
    }
    return 0;
  });
  return documents;
}

export function sortByInputType(a, b) {
  const aHasValue = a.docRequirements.some(req => req.inputType === VALUE);
  const bHasValue = b.docRequirements.some(req => req.inputType === VALUE);

  if (aHasValue && !bHasValue) {
    return -1;
  }
  if (!aHasValue && bHasValue) {
    return 1;
  }
  return 0;
}

export function findDocForEveryCategory(
  docTypeDocNameMapping,
  inputDocs,
  values,
  isEditMode,
) {
  const submittedDocs = Object.keys(values).filter(key => {
    // check if input type is value
    if (inputDocs[key]) {
      return !!values[key];
    }
    // check if input type is document
    return values[key] instanceof File || (isEditMode && !!values[key]);
  });

  const submittedDocCategory = {};

  submittedDocs.forEach(key => {
    if (docTypeDocNameMapping[key])
      submittedDocCategory[docTypeDocNameMapping[key]] = true;
  });

  // Extracting values from the mapping object
  const docCategories = Object.values(docTypeDocNameMapping);

  // Using Set to get distinct values
  const distinctValues = docCategories.filter(
    (value, index, self) => self.indexOf(value) === index,
  );

  const output = distinctValues.every((category: string) =>
    // eslint-disable-next-line no-prototype-builtins
    submittedDocCategory.hasOwnProperty(category),
  );
  return output;
}

export const prepareDocumentsObj = vendorDocs => {
  const { documents = [] } = vendorDocs;

  const documentList = [];
  const docValues = {};
  const docStatus = {};
  const inputDocs = {};
  const fileDocs = {};
  const docTypeDocNameMapping = {};
  const docsRejectionReason = {};

  JSON.parse(JSON.stringify(documents))
    .sort(sortByInputType)
    .forEach(obj => {
      const { docCategory, docRequirements } = obj;
      // since we have to assume everything is recommended
      documentList.push(JSON.parse(JSON.stringify(docRequirements)));
      docRequirements.forEach((doc: any) => {
        const {
          docName,
          docValue,
          docStatus: status,
          remarks,
          inputType,
        } = doc;
        docValues[docName] = docValue;
        docStatus[docName] = status;
        docTypeDocNameMapping[docName] = docCategory;

        if (inputType === 'VALUE') {
          inputDocs[docName] = docCategory;
        } else {
          fileDocs[docName] = docCategory;
        }

        if (remarks !== null) {
          docsRejectionReason[docName] = remarks;
        }
      });
    });

  return {
    docList: documentList,
    documentValues: docValues,
    documentStatus: docStatus,
    inputDocuments: inputDocs,
    fileDocuments: fileDocs,
    documentRejectionReason: docsRejectionReason,
    documentTypeDocNameMapping: docTypeDocNameMapping,
  };
};
